import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PessoaExamePeriodicidadeCadastroComponent } from './pessoa-exame-periodicidade-cadastro/pessoa-exame-periodicidade-cadastro.component';
import { DebounceClickModule } from '../libs/debounce-click/debounce-click.module';
import { DialogAllModule } from '@syncfusion/ej2-angular-popups';
import { ReactiveFormsModule } from '@angular/forms';
import { CrudBarModule } from '../libs/crud-bar/crud-bar.module';
import { ButtonModule, CheckBoxAllModule } from '@syncfusion/ej2-angular-buttons';
import { GridAllModule } from '@syncfusion/ej2-angular-grids';
import { TabAllModule, ToolbarAllModule } from '@syncfusion/ej2-angular-navigations';
import { DatePickerAllModule, DateRangePickerModule } from '@syncfusion/ej2-angular-calendars';
import { NumericTextBoxAllModule, TextBoxAllModule } from '@syncfusion/ej2-angular-inputs';
import { LightInfoModule } from '../libs/light-info/light-info.module';
import { EditButtonModule } from '../libs/edit-button/edit-button.module';
import { ErrorHandlerModule } from '../libs/error-handler/error-handler.module';
import { DropDownButtonAllModule, SplitButtonAllModule } from '@syncfusion/ej2-angular-splitbuttons';
import { PanelModule } from '../libs/panel/panel.module';
import { ChartAllModule } from '@syncfusion/ej2-angular-charts';
import { PesquisaModule } from '../pesquisa/pesquisa.module';
import { AxSelectModule } from '../libs/ax-select/ax-select.module';



@NgModule({
  declarations: [
    PessoaExamePeriodicidadeCadastroComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    CrudBarModule,
    ButtonModule,
    GridAllModule,
    ToolbarAllModule,
    DateRangePickerModule,
    DatePickerAllModule,
    NumericTextBoxAllModule,
    TextBoxAllModule,
    CheckBoxAllModule, 
    LightInfoModule,
    EditButtonModule,
    ErrorHandlerModule,
    PesquisaModule,
    SplitButtonAllModule,
    PanelModule,
    AxSelectModule,
    TabAllModule,
    PesquisaModule,
    ChartAllModule,
    DropDownButtonAllModule,
    DialogAllModule,
    DebounceClickModule,
  ],
  exports: [
    PessoaExamePeriodicidadeCadastroComponent
  ]
})
export class PeriodicidadeModule { }
